// Sign-backend refuses signature images over 2048 px a side or 4 MP (cpDocumentSignaturePdf.service).
// A phone photo of a signature is far larger, so scale it down here rather than fail at preview.
export const MAX_SIGNATURE_SIDE = 2048;
export const MAX_SIGNATURE_PIXELS = 4 * 1024 * 1024;

export async function fitSignatureImage(file) {
  // Without image decoding (older browsers, tests) the file goes as is; the server still checks it.
  if (typeof createImageBitmap !== "function" || typeof document === "undefined") return file;
  let bitmap;
  try { bitmap = await createImageBitmap(file); } catch { return file; }
  try {
    const { width, height } = bitmap;
    const scale = Math.min(1, MAX_SIGNATURE_SIDE / width, MAX_SIGNATURE_SIDE / height, Math.sqrt(MAX_SIGNATURE_PIXELS / (width * height)));
    if (scale >= 1) return file;
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.floor(width * scale));
    canvas.height = Math.max(1, Math.floor(height * scale));
    const context = canvas.getContext("2d");
    if (!context) return file;
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, file.type, 0.92));
    if (!blob) return file;
    return new File([blob], file.name || "signature", { type: file.type });
  } finally {
    bitmap.close?.();
  }
}
